(() => {
  'use strict';

  if (window.__wubAtcBehaviorLoaded) return;
  window.__wubAtcBehaviorLoaded = true;

  const DRAWER_HISTORY_KEY = 'wubCartDrawerOpen';

  const escapeCss = (value) => window.CSS?.escape
    ? window.CSS.escape(String(value))
    : String(value).replace(/["\\]/g, '\\$&');

  const toInt = (value, fallback = 0) => {
    const parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? fallback : parsed;
  };

  const historyState = () => (
    window.history.state && typeof window.history.state === 'object'
      ? window.history.state
      : {}
  );

  const hasDrawerHistoryState = () => historyState()[DRAWER_HISTORY_KEY] === true;

  const currentDrawer = () => document.getElementById('WubCartDrawer');
  const drawerIsOpen = () => currentDrawer()?.classList.contains('is-open') === true;

  function stickyRoot(sectionId) {
    if (!sectionId) return null;
    return document.querySelector(`product-add-to-cart-sticky[data-section="${escapeCss(sectionId)}"]`);
  }

  function mainAtcRoot(sectionId) {
    if (!sectionId) return null;
    return document.querySelector(`[data-wub-product-atc][data-section-id="${escapeCss(sectionId)}"]`);
  }

  function syncStickyQuantity(sectionId, quantity) {
    const input = stickyRoot(sectionId)?.querySelector('[data-wub-sticky-quantity-input]');
    if (!input) return;
    const next = Math.max(1, toInt(quantity, 1));
    input.value = String(next);
  }

  function updateQuantityButtons(sectionId, quantity, variant = null) {
    const root = mainAtcRoot(sectionId);
    const input = root?.querySelector('[data-wub-quantity-input]');
    if (!root || !input) return;

    const min = Math.max(1, toInt(variant?.quantity_rule?.min ?? input.min, 1));
    const maxRaw = variant?.quantity_rule?.max ?? input.max;
    const parsedMax = maxRaw == null || maxRaw === '' ? null : toInt(maxRaw, null);
    const value = Math.max(min, toInt(quantity ?? input.value, min));
    const minus = root.querySelector('[data-wub-quantity-minus]');
    const plus = root.querySelector('[data-wub-quantity-plus]');

    if (minus) minus.disabled = value <= min;
    if (plus) plus.disabled = parsedMax !== null && value >= parsedMax;
  }

  function syncFromProductState(detail = {}) {
    const sectionId = String(detail.sectionId || '');
    if (!sectionId) return;
    syncStickyQuantity(sectionId, detail.quantity);
    updateQuantityButtons(sectionId, detail.quantity, detail.variant || null);
  }

  document.addEventListener('wub:product-state-change', (event) => {
    syncFromProductState(event.detail || {});
  });

  const syncFromQuantityInput = (target) => {
    const input = target?.closest?.('[data-wub-quantity-input]');
    if (!input) return;
    const root = input.closest('[data-wub-product-atc]');
    const sectionId = root?.dataset?.sectionId;
    if (!sectionId) return;
    const quantity = Math.max(1, toInt(input.value, 1));
    syncStickyQuantity(sectionId, quantity);
    updateQuantityButtons(sectionId, quantity);
  };

  document.addEventListener('input', (event) => syncFromQuantityInput(event.target));
  document.addEventListener('change', (event) => syncFromQuantityInput(event.target));

  function enhanceDrawerStatus() {
    const status = document.querySelector('[data-wub-cart-status]');
    if (!status) return;
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
  }

  function pushDrawerHistoryState() {
    if (hasDrawerHistoryState()) return;
    window.history.pushState(
      { ...historyState(), [DRAWER_HISTORY_KEY]: true },
      '',
      window.location.href
    );
  }

  function removeDrawerHistoryStateWithBack() {
    if (!hasDrawerHistoryState()) return;
    window.history.back();
  }

  document.addEventListener('wub:cart-drawer-opened', () => {
    enhanceDrawerStatus();
    pushDrawerHistoryState();
  });

  document.addEventListener('click', (event) => {
    const close = event.target.closest?.('[data-wub-cart-close]');
    if (!close || !hasDrawerHistoryState()) return;
    queueMicrotask(removeDrawerHistoryStateWithBack);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !drawerIsOpen() || !hasDrawerHistoryState()) return;
    queueMicrotask(removeDrawerHistoryStateWithBack);
  });

  window.addEventListener('popstate', () => {
    const markedOpen = hasDrawerHistoryState();
    const open = drawerIsOpen();

    if (!markedOpen && open) {
      window.WUBCommerce?.closeDrawer({ restoreFocus: true });
      return;
    }

    if (markedOpen && !open) {
      window.WUBCommerce?.openDrawer({ added: false });
    }
  });

  function normalizeInitialState() {
    enhanceDrawerStatus();
    document.querySelectorAll('[data-wub-product-atc][data-section-id]').forEach((root) => {
      const input = root.querySelector('[data-wub-quantity-input]');
      if (!input) return;
      const sectionId = root.dataset.sectionId;
      const quantity = Math.max(1, toInt(input.value, 1));
      syncStickyQuantity(sectionId, quantity);
      updateQuantityButtons(sectionId, quantity);
    });

    if (hasDrawerHistoryState() && !drawerIsOpen()) {
      const nextState = { ...historyState() };
      delete nextState[DRAWER_HISTORY_KEY];
      window.history.replaceState(nextState, '', window.location.href);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', normalizeInitialState, { once: true });
  } else {
    normalizeInitialState();
  }
})();
